import { Drop, Boat, Wrench, Flame, Stack } from "@phosphor-icons/react";

export const SERVICES = [
  {
    number: "01",
    title: "Petroleum Products Trading",
    short:
      "Reliable supply of DPK, PMS, AGO and refined products through our refinery hubs.",
    description:
      "We source and distribute high-quality petroleum products — Dual Purpose Kerosene (DPK), Premium Motor Spirit (PMS) and Automotive Gas Oil (AGO) — from strategic refinery hubs in Port Harcourt, Kaduna and Warri. Our market intelligence network keeps response times short and pricing competitive across volatile market cycles.",
    Icon: Drop,
    image:
      "https://images.pexels.com/photos/5884386/pexels-photo-5884386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "02",
    title: "Shipping, Storage & Logistics",
    short:
      "End-to-end fuel logistics across Nigeria and West Africa with secure storage.",
    description:
      "Our shipping and logistics arm streamlines movement and storage of petroleum products across Nigeria and West Africa. From bunkering to cost-effective haulage and tank-farm storage, we manage the entire chain with a focus on safety, traceability and on-time delivery.",
    Icon: Boat,
    image:
      "https://images.pexels.com/photos/9806482/pexels-photo-9806482.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "03",
    title: "Pipeline Construction & Maintenance",
    short:
      "Engineering, building and maintaining pipelines that move energy safely.",
    description:
      "We design, construct and maintain mainline and distribution pipelines using advanced engineering practices. Our capabilities include hot tapping, corrosion prevention, integrity inspections and rapid-response repair — keeping critical energy infrastructure running across the region.",
    Icon: Wrench,
    image:
      "https://images.pexels.com/photos/36825977/pexels-photo-36825977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "04",
    title: "Natural Gas Distribution & Power",
    short:
      "Cleaner-burning gas infrastructure powering industries and communities.",
    description:
      "In partnership with the Nigerian Gas Company (NGC) and NGMC, we are building modern natural gas infrastructure — including an 18\" × 153 km transmission pipeline and a Compressed Natural Gas (CNG) facility — to deliver cleaner, reliable power to industries and homes.",
    Icon: Flame,
    image:
      "https://images.pexels.com/photos/29056690/pexels-photo-29056690.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "05",
    title: "Upstream Support & Drilling",
    short:
      "Drilling rigs, well logging, mud control and field support services.",
    description:
      "We provide a full suite of upstream services to indigenous operators and IOCs — drilling rig supply, well logging, mud control and field engineering — designed to optimise hydrocarbon production while meeting the highest standards of safety and operational discipline.",
    Icon: Stack,
    image:
      "https://images.pexels.com/photos/18545023/pexels-photo-18545023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const STATS = [
  { value: "80+", label: "Completed Projects" },
  { value: "15+", label: "Strategic Partners" },
  { value: "100%", label: "Customer Satisfaction" },
  { value: "153km", label: "Gas Pipeline Network" },
];

export const VALUES = [
  {
    title: "Safety first",
    description:
      "Every operation begins and ends with safeguarding people, communities and the environment.",
  },
  {
    title: "Engineering excellence",
    description:
      "Industry specialists, decades of field experience and modern tooling on every project.",
  },
  {
    title: "Integrated thinking",
    description:
      "From upstream support to distribution — one accountable partner across the energy chain.",
  },
  {
    title: "Sustainable impact",
    description:
      "We invest in cleaner gas, durable infrastructure and the long-term growth of African economies.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Fradro Group's innovative energy solutions transformed our operational efficiency and set a new benchmark in the industry.",
    name: "Director, Industrial Operations",
    company: "Confidential — Energy Sector",
  },
  {
    quote:
      "The reliability and strategic insight Fradro provides have been instrumental to our growth. Their project management and engineering are unmatched.",
    name: "Senior Executive",
    company: "Confidential — Manufacturing",
  },
  {
    quote:
      "Working with Fradro on a regional pipeline programme gave us confidence at every milestone. Disciplined execution from start to finish.",
    name: "Head of Infrastructure",
    company: "Confidential — Public Sector",
  },
];

export const INDUSTRIES = [
  {
    title: "Oil & Gas Operators",
    description:
      "Drilling, well logging and mud control for indigenous and international producers.",
    image:
      "https://images.pexels.com/photos/5884386/pexels-photo-5884386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Power Generation",
    description:
      "Natural gas supply for IPPs, captive power plants and industrial CHP systems.",
    image:
      "https://images.pexels.com/photos/29056690/pexels-photo-29056690.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Manufacturing",
    description:
      "Cleaner, cheaper gas to fuel furnaces, boilers and continuous-process plants.",
    image:
      "https://images.pexels.com/photos/36825977/pexels-photo-36825977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Marine & Bunkering",
    description:
      "Vessel-side fuel supply, storage and inland haulage across Nigerian waterways.",
    image:
      "https://images.pexels.com/photos/9806482/pexels-photo-9806482.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Public Infrastructure",
    description:
      "Long-haul pipeline corridors and distribution networks for federal and state programmes.",
    image:
      "https://images.pexels.com/photos/18545023/pexels-photo-18545023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Commercial & Retail",
    description:
      "Reliable petroleum supply for fleets, filling stations and large commercial estates.",
    image:
      "https://images.pexels.com/photos/7794060/pexels-photo-7794060.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const PARTNERS = [
  "NGC",
  "NGMC",
  "NNPC",
  "DPR",
  "NIPCO",
  "Total Energies",
  "Shell",
  "Chevron",
  "Mobil",
  "Oando",
];
